import React from 'react';
import { SmartLink } from '../SmartLink';
import { CategoryChip, DateRead } from './ArticleMeta';
import { getAuthor } from '../../data/articles/authors';
import type { Article } from '../../types/article';
export function FeaturedArticle({
  article
}: {
  article: Article;
}) {
  const author = getAuthor(article.authorId);
  return <SmartLink href={`/blog/${article.slug}`} className="group grid grid-cols-1 overflow-hidden rounded-[16px] bg-white shadow-[0_24px_48px_-32px_rgba(11,11,11,0.28)] lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)]" data-id="element-131" data-mp="2by52knnk2jje">
      <div className="overflow-hidden" data-id="element-132" data-mp="34jofd9nt3r0h">
        <img src={article.image} alt={article.alt} className="h-[240px] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02] sm:h-[360px] lg:h-full lg:min-h-[420px]" data-id="element-133" data-mp="2zlmuqkaqfjmw" />
      </div>
      <div className="flex flex-col p-7 sm:p-10" data-id="element-134" data-mp="1o54yolb1rj0s">
        <div className="flex items-center gap-2" data-id="element-135" data-mp="1k5e92kx9b8xu">
          <span className="text-[13px] font-semibold text-brand" data-id="element-136" data-mp="1k80iyr7me0j8">Featured</span>
          <CategoryChip label={article.category} data-id="element-137" data-mp="199qkv6quuarz" />
        </div>
        <h2 className="display mt-4 text-[28px] font-semibold text-ink transition-colors duration-150 ease-out group-hover:text-brand sm:text-[36px]" data-id="element-138" data-mp="1e8aabh4nq4p3">
          {article.title}
        </h2>
        <p className="mt-4 line-clamp-2 text-[17px] leading-[1.55] text-ink-soft" data-id="element-139" data-mp="149b74e2nv19h">{article.excerpt}</p>
        <div className="mt-8 flex items-center gap-3 lg:mt-auto" data-id="element-140" data-mp="qi6555btlwvz">
          <img src={author.photo} alt="" className="h-10 w-10 rounded-full object-cover" data-id="element-141" data-mp="v9622akxweyh" />
          <div data-id="element-142" data-mp="vazbfxmxtda6">
            <p className="text-[14px] font-semibold text-ink" data-id="element-143" data-mp="gkjoadaynv9d">{author.name}</p>
            <DateRead date={article.date} minutes={article.readMinutes} data-id="element-144" data-mp="gifa92jclfvd" />
          </div>
        </div>
      </div>
    </SmartLink>;
}